if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});

		}

		onResizeHandler(){
			this._resetTransform();
		}

		_resetTransform() {
			this.scale = this.minScale || 1;
			this.panX = 0;
			this.panY = 0;
			this._applyTransform();
		}

		_applyTransform() {
			this.image.style.transform = `scale(${this.scale}) translate(${this.panX}px, ${this.panY}px)`;
		}

		_productZoomMount() {

			this.minScale = window.innerWidth <= 768 ? 1.75 : 1;
			this.scale = this.minScale;
			this.panX = 0;
			this.panY = 0;

			this.image.setAttribute('draggable', 'false');
			this.image.style.userSelect = 'none';
			this.image.style.webkitUserSelect = 'none';

			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});

			// --- Mouse wheel zoom (desktop) ---
			this._onWheel = (e) => {
				e.preventDefault();
				const delta = e.deltaY > 0 ? -0.15 : 0.15;
				this.scale = Math.min(5, Math.max(this.minScale, this.scale + delta));
				if (this.scale === this.minScale) { this.panX = 0; this.panY = 0; }
				this._applyTransform();
			};
			this.zoom.addEventListener('wheel', this._onWheel, {passive: false});

			// --- Mouse drag to pan (desktop) ---
			this._isDragging = false;
			this._dragStartX = 0;
			this._dragStartY = 0;
			this._dragPanX = 0;
			this._dragPanY = 0;

			this._onMouseDown = (e) => {
				e.preventDefault();
				if (this.scale <= this.minScale) return;
				this._isDragging = true;
				this._dragStartX = e.clientX;
				this._dragStartY = e.clientY;
				this._dragPanX = this.panX;
				this._dragPanY = this.panY;
				this.zoom.style.cursor = 'grabbing';
			};
			this._onMouseMove = (e) => {
				if (!this._isDragging) return;
				const dx = (e.clientX - this._dragStartX) / this.scale;
				const dy = (e.clientY - this._dragStartY) / this.scale;
				this.panX = this._dragPanX + dx;
				this.panY = this._dragPanY + dy;
				this._applyTransform();
			};
			this._onMouseUp = () => {
				this._isDragging = false;
				this.zoom.style.cursor = this.scale > this.minScale ? 'grab' : 'default';
			};
			this.zoom.addEventListener('mousedown', this._onMouseDown);
			window.addEventListener('mousemove', this._onMouseMove);
			window.addEventListener('mouseup', this._onMouseUp);

			// --- Pinch to zoom + pan (mobile, Safari compatible) ---
			this._lastPinchDist = null;
			this._isDragging = false;

			this._onTouchStart = (e) => {
				if (e.touches.length === 2) {
					this._isDragging = false;
					const dx = e.touches[0].clientX - e.touches[1].clientX;
					const dy = e.touches[0].clientY - e.touches[1].clientY;
					this._lastPinchDist = Math.sqrt(dx*dx + dy*dy);
					this._pinchStartScale = this.scale;
				} else if (e.touches.length === 1 && this.scale > this.minScale) {
					this._isDragging = true;
					this._dragStartX = e.touches[0].clientX;
					this._dragStartY = e.touches[0].clientY;
					this._dragPanX = this.panX;
					this._dragPanY = this.panY;
				}
			};

			this._onTouchMove = (e) => {
				if (e.touches.length === 2 && this._lastPinchDist !== null) {
					e.preventDefault();
					const dx = e.touches[0].clientX - e.touches[1].clientX;
					const dy = e.touches[0].clientY - e.touches[1].clientY;
					const dist = Math.sqrt(dx*dx + dy*dy);
					const rawRatio = dist / this._lastPinchDist;
					const dampedRatio = 1 + (rawRatio - 1) * 0.15;
					this.scale = Math.min(5, Math.max(this.minScale, this.scale * dampedRatio));
					this._lastPinchDist = dist;
					if (this.scale === this.minScale) { this.panX = 0; this.panY = 0; }
					this._applyTransform();
				} else if (e.touches.length === 1 && this._isDragging) {
					e.preventDefault();
					const dx = (e.touches[0].clientX - this._dragStartX) / this.scale;
					const dy = (e.touches[0].clientY - this._dragStartY) / this.scale;
					this.panX = this._dragPanX + dx;
					this.panY = this._dragPanY + dy;
					this._applyTransform();
				}
			};

			this._onTouchEnd = (e) => {
				if (e.touches.length < 2) {
					this._lastPinchDist = null;
				}
				if (e.touches.length === 0) {
					this._isDragging = false;
				}
			};

			// Safari vereist passive:false op het element zelf voor preventDefault te werken
			this.zoom.addEventListener('touchstart', this._onTouchStart, {passive: true});
			this.zoom.addEventListener('touchmove', this._onTouchMove, {passive: false});
			this.zoom.addEventListener('touchend', this._onTouchEnd, {passive: true});

			// Extra Safari fix: blokkeer native page pinch-zoom tijdens onze zoom
			this._onGestureStart = (e) => e.preventDefault();
			this._onGestureChange = (e) => e.preventDefault();
			document.addEventListener('gesturestart', this._onGestureStart, {passive: false});
			document.addEventListener('gesturechange', this._onGestureChange, {passive: false});

			setTimeout(()=>{
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this._onMouseMove);
				window.removeEventListener('mouseup', this._onMouseUp);
				this.zoom.removeEventListener('wheel', this._onWheel);
				this.zoom.removeEventListener('mousedown', this._onMouseDown);
				this.zoom.removeEventListener('touchstart', this._onTouchStart);
				this.zoom.removeEventListener('touchmove', this._onTouchMove);
				this.zoom.removeEventListener('touchend', this._onTouchEnd);
				document.removeEventListener('gesturestart', this._onGestureStart);
				document.removeEventListener('gesturechange', this._onGestureChange);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
				this.zoom.style.cursor = '';
			}, 300);

		}

	}

	if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}